import axios from 'axios';

const host = process.env.REACT_APP_API_V2;
const headers = {
  'X-Space': 'sure',
};
const axiosOverride = axios.create();
axiosOverride.defaults.headers.common = headers;

function useTokenExchange(token) {
  return new Promise((resolve, reject) => {
    axiosOverride
      .post(`${host}/api/auth/v1/assurant-token-exchange/`, {
        token,
      })
      .then(response => {
        return resolve(response);
      })
      .catch(error => reject(error));
  });
}

export default useTokenExchange;
